export default {
    email: "amualumnisingapore@gmail.com",
    number: "+6566409491",
    facebook: 'https://www.facebook.com/groups/449282285274148/about',
    instagram: '',
    twitter: '',
    youtube:''
}